const SupportPage = () => {
  return (
    <div style={{ padding: "2rem", textAlign: "center", displa: "flex", justifyContent: "center" }}>
      <h1>Non User Support Page</h1>
      <p>Nothing to see here yet guys. Content coming soon!</p>
    </div>
  );
};

export default SupportPage;
